module.exports = __webpack_public_path__ + "img/toptext.494319c3.svg";